import React from 'react';
import { Heart } from 'lucide-react';

export interface FavoriteIconProps {
  size?: number | string;
  /** Pass "currentColor" for a filled heart, "none" for outlined */
  fill?: string;
  className?: string;
}

/**
 * Unified favorite icon using lucide-react Heart.
 * fill="currentColor" -> filled heart (= is favorite)
 * fill="none"         -> outlined heart (= not yet favorite)
 */
export const FavoriteIcon = React.forwardRef<SVGSVGElement, FavoriteIconProps>(
  ({ size = 24, fill = 'none', className = '' }, ref) => {
    const isFilled = fill && fill !== 'none';
    return (
      <Heart
        ref={ref}
        size={Number(size)}
        fill={isFilled ? 'currentColor' : 'none'}
        className={className}
      />
    );
  }
);

FavoriteIcon.displayName = 'FavoriteIcon';
